<div class="announcements-container">
    <div class="page-section-header">
      <div *ngIf="!isLoading" class="page-section-buttons">
        <a (click)="activeAnnouncements.length === 0 ? doCreate() : null" tabindex="0" (keypress)="activeAnnouncements.length === 0 ? doCreate() : null"
           class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon"
           [ngClass]="{'disabled': activeAnnouncements.length > 0}"
           [style.opacity]="activeAnnouncements.length > 0 ? '0.6' : '1'"
           [title]="activeAnnouncements.length > 0 ? 'Only one announcement can be shown at a time' : ''">
          <svg-icon icon="plus" alt="plus"></svg-icon>
          <span translate>Create Announcement</span>
        </a>
      </div>
      <h2>Announcement Activities</h2>
    </div>
  
    <!-- Announcements List -->
    <div class="announcements-list">
      <div *ngIf="isLoading" class="loading">
        Loading announcements...
      </div>
      
      <div *ngIf="!isLoading && activeAnnouncements.length === 0 && expiredAnnouncements.length === 0" class="no-announcements">
        No announcements available
      </div>
  
      <div *ngIf="!isLoading && (activeAnnouncements.length > 0 || expiredAnnouncements.length > 0)" class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th style="width: 30%">Message Title</th>
              <th style="width: 15%">Start Date</th>
              <th style="width: 15%">End Date</th>
              <th style="width: 10%">Status</th>
              <th style="width: 10%"></th>
              <th style="width: 10%" class="text-center">Actions</th>
              <th style="width: 10%"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let announcement of activeAnnouncements">
              <td>{{ announcement.Title }}</td>
              <td>{{ announcement.StartDate | date }}</td>
              <td>{{ announcement.EndDate | date }}</td>
              <td>Active</td>
              <td><a tabindex="0" role="button" class="pull-right" (keypress)="viewAnnouncement(announcement)" (click)="viewAnnouncement(announcement)" translate>View</a></td>
              <td><a tabindex="0" role="button" class="pull-right" (keypress)="editAnnouncement(announcement)" (click)="editAnnouncement(announcement)" translate>Edit</a></td>   
              <td><a tabindex="0" role="button" class="pull-right" (keypress)="endAnnouncement(announcement)" (click)="endAnnouncement(announcement)" translate>End</a></td>
            </tr>
            <tr *ngFor="let announcement of expiredAnnouncements" class="expired">
              <td>{{ announcement.Title }}</td>
              <td>{{ announcement.StartDate | date }}</td>
              <td>{{ announcement.EndDate | date }}</td>
              <td>Expired</td> 
              <td><a tabindex="0" role="button" class="pull-right" (keypress)="viewAnnouncement(announcement)" (click)="viewAnnouncement(announcement)" translate>View</a></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div> 